import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { BlogPostForm, type BlogPostFormInitial } from "@/components/admin/BlogPostForm";
import { adminBlogPostQuery } from "@/lib/query-registry";

export const Route = createFileRoute("/admin/blog/$id")({
  validateSearch: (search: Record<string, unknown>) => ({ lang: search.lang === "es" ? "es" as const : "en" as const }),
  component: EditBlogPost,
});

function EditBlogPost() {
  const { id } = Route.useParams();
  const { lang } = Route.useSearch();
  const query = useQuery(adminBlogPostQuery(id));

  return (
    <div>
      <Link to="/admin/blog" className="text-sm text-muted-foreground hover:text-foreground">
        ← Back to blog
      </Link>
      <h1 className="mt-3 font-display text-3xl font-semibold tracking-tight text-foreground">
        Edit post
      </h1>
      <div className="mt-8">
        {query.isPending && <p className="text-sm text-muted-foreground">Loading…</p>}
        {query.isError && (
          <div className="flex items-center gap-3">
            <p className="text-sm text-destructive">{query.error.message}</p>
            <button
              type="button"
              onClick={() => query.refetch()}
              className="rounded-full border border-border px-4 py-1.5 text-xs font-medium text-foreground hover:bg-card"
            >
              Retry
            </button>
          </div>
        )}
        {query.isSuccess && query.data?.post && (
          <BlogPostForm initial={query.data.post as unknown as BlogPostFormInitial} initialLocale={lang} />
        )}
        {query.isSuccess && !query.data?.post && (
          <p className="text-sm text-muted-foreground">Post not found.</p>
        )}
      </div>
    </div>
  );
}
